import { digits } from "@/lib/api";
import { validDoc } from "@/lib/document";

export const STEPS = ["Dados básicos", "Veículo", "Região", "Documentos", "Dados bancários"];
export const VEHICLES = [
  { id: "moto", label: "Moto", hint: "CNH categoria A", cnh: "A" },
  { id: "carro", label: "Carro", hint: "CNH categoria B", cnh: "B" },
  { id: "bike", label: "Bike / Bicicleta", hint: "Sem CNH necessária" },
];
export const VEHICLE_LABEL = { moto: "Moto", carro: "Carro", bike: "Bike" };
export const DOC_LABELS = { cnh_front: "CNH (frente)", cnh_back: "CNH (verso)", cnh_digital: "CNH digital", selfie: "Selfie com documento" };
export const DOC_KINDS = ["cnh_front", "cnh_back", "cnh_digital", "selfie"];
export const ACCOUNT_TYPES = { corrente: "Conta corrente", poupanca: "Conta poupança" };
export const POPULAR_BANKS = ["001", "104", "237", "341", "033", "260", "077", "336", "290", "323", "380", "756", "748", "212", "422"];
export const EMPTY = {
  cpf: "", name: "", phone: "", email: "", vehicle: "", city: "", state: "", cep: "", cnhMode: "foto",
  cnh_front: null, cnh_back: null, cnh_digital: null, selfie: null,
  bank: { code: "", name: "", type: "corrente", agency: "", account: "" },
};

const EMAIL = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;
export const normCity = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const checkBasic = (f) => (digits(f.cpf).length !== 11 || !validDoc(digits(f.cpf)) ? "CPF inválido"
  : f.name.trim().split(/\s+/).length < 2 ? "Informe o nome completo, igual ao documento"
    : ![10, 11].includes(digits(f.phone).length) ? "Informe o celular com DDD"
      : !EMAIL.test(f.email.trim()) ? "Informe um e-mail válido" : "");

export const checkDocs = (f) => (!f.selfie ? "Envie a selfie segurando o documento ao lado do rosto"
  : f.vehicle === "bike" ? ""
    : f.cnhMode === "digital" ? (f.cnh_digital ? "" : "Envie a CNH digital")
      : !f.cnh_front || !f.cnh_back ? "Envie a foto da frente e do verso da CNH" : "");

export const checkBank = (b) => (!b.code ? "Escolha o banco" : !digits(b.agency) ? "Informe a agência sem o dígito"
  : !/^\d{1,15}-[0-9X]$/.test(b.account) ? "Informe o número da conta com o dígito" : "");

export const maskAccount = (v) => {
  const d = v.toUpperCase().replace(/[^0-9X]/g, "").replace(/X(?=.)/g, "").slice(0, 16);
  return d.length > 1 ? `${d.slice(0, -1)}-${d.slice(-1)}` : d;
};

const fileOf = (v) => v && { path: v.path, content_type: v.content_type };
export function payloadOf(f) {
  const cnh = f.vehicle === "bike" ? {} : f.cnhMode === "digital" ? { cnh_digital: fileOf(f.cnh_digital) }
    : { cnh_front: fileOf(f.cnh_front), cnh_back: fileOf(f.cnh_back) };
  return {
    cpf: digits(f.cpf), name: f.name.trim(), phone: digits(f.phone), email: f.email.trim(), vehicle: f.vehicle,
    city: f.city, state: f.state, cep: digits(f.cep), selfie: fileOf(f.selfie), ...cnh,
    bank: { code: f.bank.code, type: f.bank.type, agency: digits(f.bank.agency), account: f.bank.account },
  };
}

export async function shrinkImage(file, max = 1600) {
  if (!file.type.startsWith("image/")) return file;
  try {
    const bmp = await createImageBitmap(file);
    const k = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const c = document.createElement("canvas");
    c.width = Math.round(bmp.width * k);
    c.height = Math.round(bmp.height * k);
    c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
    const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.85));
    return blob ? new File([blob], "foto.jpg", { type: "image/jpeg" }) : file;
  } catch {
    return file;
  }
}
